import { getStateChipLabel, getStateTone } from "./voiceStateLabels";
import css from "./AssistantDock.module.scss";

// The one-word state readout at the left of the bar. Announced politely so a
// screen reader reports "Thinking" without stealing focus from the page the
// user is still working in.
const DockStatusChip = ({ voiceState }) => (
  <span
    className={css.statusChip}
    role="status"
    aria-live="polite"
    data-state={voiceState}
    style={{ "--chip-tone": getStateTone(voiceState) }}
  >
    <span className={css.statusDot} aria-hidden="true" />
    {getStateChipLabel(voiceState)}
  </span>
);

export default DockStatusChip;
